<script>
import log from '@/common/log';
import {AllPlans} from '@/plans';
import { h } from 'vue';
export default {
  props: {
    group: {
      type: String,
      default: undefined,
    },
    filter: {
      type: Function,
      default: list => list,
    },
    filterKeys: {
      type: Array,
      default: () => [],
    },
  },
  render() {
    const list = AllPlans.filter((x) => {
      if (!x.components?.addon) return false;
      return true;
    });

    const filterAddons = this.filterKeys.map((key) => list.find((x) => x.key === key)).filter(key => key);

    const addons = filterAddons.filter(x => {
      const _group = x.components?.addon?.group;
      const group = typeof _group === 'function' ? _group() : _group;
      return this.group === group;
    });
    const filter = window.__hook_addons_filter__ || this.filter;

    let filtered = filter(addons);
    log('config:addons', filtered);
    if (!filtered.length) return;
    return h(
      'div',
      {},
      [
        this.$slots.default?.(),
        filtered.map((x) =>
          h(x.components.addon, {
            ...{
              isSuccessPage: true
            },
            onAdd: ($data) => {
              this.$emit('add', x.key, $data, x);
            },
          }),
        ),
      ],
    );
  },
};
</script>
